module.exports = __webpack_public_path__ + "static/img/watermelonlimebublyburst_th.6a64ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/watermelonlimebublyburst_th.png
// module id = 9IlA
// module chunks = 0